import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const LiveStockPage = styled.div`
  width: 100%;
  height: 100%;
  .button-group{
    width: 100%;
    margin-left: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  .search-bar {
    background: rgba(143, 146, 161, 0.05);
    border-radius: 12px;
    border: none;
    height:40px;
    margin-left: 2rem;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    flex-direction: row-reverse;
    max-width: 228px;
  }
  .site-form-item-icon {
    height: 19px;
    width: 19px;
    color: #8F92A1;
    font-size: 19px;
  }
  .site-form-item-cancel {
    height: 15px;
    width: 15px;
    color: #8F92A1;
    font-size: 15px;
  }
  .search-bar .ant-input {
    background: none!important;
    border: none!important;
    color: #8F92A1;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  .colorclass{
    display: flex;
    padding: 5px 10px;
    border-radius: 10px;
    gap: 6px;
    max-width: 130px;
    align-items: center;
  }
  .btn-success{
    background-color: #0B2A1B !important;
    border-color: #0B2A1B;
    height : 40px ;
    max-width : 180px;
    border-radius : 8px;
    &:hover{
      opacity: 0.8;
    }
  } 
  .manage-table .react-collapsible tbody .tag_number_range {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #101828;
  }
  .manage-property-header {
    padding: 20px 24px;
    display: flex;
    align-items: center;
    margin: auto;
  }
  .manage-table .react-collapsible tbody .name {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #101828;
}
  
  .ant-table-wrapper {
    min-width: 100%;
  }
  .fAgWDa .ant-table-content{
    overflow-x: unset;
  }
  .fAgWDa{
    overflow-x: unset;
  }
  .dtr-data{
    white-space: break-spaces;
  }
  .delete-button{
    margin-left:8px;
  }
  .dataTables_filter{
    margin-bottom:10px;
  }
  .dataTables_filter .input-sm{
    margin-left:10px;
  }
  .dataTables_filter .input-sm{
    margin-left:10px;
    text-align:center;
    outline-offset: unset;
    border-radius: 8px;
  }
  .react-collapsible-theme .react-collapsible-search input{
    text-align: center;
    border: 0;
    border: 5px #C9C9CE solid;
    border-radius: 6px;
    width: 100%;
    height: 2rem;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65)
  }
  .search-icon{
    top:5px!important;
    left:15px!important;
    width:20px;
  }

  .clear-icon{
    position: relative;
    top:5px!important;
    right:2px!important;
  }

  .search-icon svg{
    color: rgba(0, 0, 0, 0.65)
  }

  .action-button.view-history-button, .action-button{
    margin-bottom:5px;
  }

  @media (max-width: 768px){
    .react-collapsible-theme .react-collapsible-search .search-input{
      width:100%;
    }
  }
  @media only screen and (max-width : 678px){
    .manage-property-header{
      flex-wrap : wrap;
    }
    .button-group{
      margin-left: 0px; 
      margin-top : 20px;
      justify-content: flex-start;

    }
  }
  @media only screen and (max-width : 435px){
  
    .button-group{
      display : block;
    }
      .btn-success{
        min-width : 100% !important;
        max-width : 100% !important;
      }
      .search-bar{
        margin-left : 0rem; 
        max-width : 100%;   
      }

  }
  .ant-spin-dot-item{
    background-color: #0B2A1B;
  }
`;

export default WithDirection(LiveStockPage);